// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block{
    min-height: 100vh;
    max-height: 100%;
}

.icons_custom{
    height: 24px;
    width: 24px;
    padding-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./src/styles/reuse/block.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".block{\r\n    min-height: 100vh;\r\n    max-height: 100%;\r\n}\r\n\r\n.icons_custom{\r\n    height: 24px;\r\n    width: 24px;\r\n    padding-bottom: 2px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
